// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  agendaId: __t.u64().primaryKey().name("agenda_id"),
  workspaceId: __t.u64().name("workspace_id"),
  roadId: __t.u64().name("road_id"),
  title: __t.string(),
  objective: __t.string(),
  orderIndex: __t.u32().name("order_index"),
  createdAt: __t.i64().name("created_at"),
});
